import { NavLink } from 'react-router-dom';

function Card({ icon, title, body, footer }) {
  return (
    <div className="bg-white border-t-4 border-brand shadow-md rounded-lg p-6 flex flex-col justify-between">
      
      {/* Icon + Text (centered) */}
      <div className="flex-1 flex flex-col items-center text-center">
        {/* Icon */}
        <div className="mb-4 text-brand text-3xl flex items-center justify-center h-12 w-12 bg-blue-100 rounded-full">
          {icon}
        </div>

        {/* Title */}
        {title && <h3 className="text-lg font-semibold mb-2">{title}</h3>}

        {/* Body */}
        <p className="text-gray-700">{body}</p>
      </div>

      {/* Footer (right-aligned) */}
      {footer && (
        <div className="mt-4 text-right text-blue-600 font-medium w-full">
           <NavLink to='/about' >
          {footer}
          </NavLink>
        </div>
      )}
    </div>
  );
}

export default Card;